/* WARMY LISTICLE — list-hs1 behavior (scoped, idempotent).
   NOTE: each lst-* section renders its own .lst-wrap wrapper, so all
   lookups are document-level (elements are unique per page). */
(() => {
  const init = () => {
    if (!document.querySelector('.lst-wrap')) return;
    const $ = (s) => document.querySelector('.lst-wrap ' + s) || document.querySelector(s);

    /* reading progress + sticky bar */
    const updateScrollState = () => {
      const progress = $('.reading-progress span');
      if (progress) {
        const root = document.documentElement;
        const scrollable = root.scrollHeight - window.innerHeight;
        const percent = scrollable > 0 ? Math.min(100, (window.scrollY / scrollable) * 100) : 0;
        progress.style.width = percent + '%';
      }
      const sticky = $('.purchase-sticky');
      if (sticky) {
        const hero = $('.article-intro');
        const show = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
        sticky.classList.toggle('is-on', show);
      }
    };
    updateScrollState();
    if (!window.__lstScrollBound) {
      window.__lstScrollBound = true;
      window.addEventListener('scroll', updateScrollState, { passive: true });
      window.addEventListener('resize', updateScrollState);
    }
    window.__lstUpdateScroll = updateScrollState;

    /* countdown */
    const updateCountdown = () => {
      const countdown = document.querySelector('.lst-wrap [data-sale-countdown]');
      if (!countdown) return;
      let end;
      if (countdown.dataset.mode === 'midnight' || !countdown.dataset.end) {
        end = new Date(); end.setHours(24, 0, 0, 0);   /* resets nightly at local midnight */
      } else {
        end = new Date(countdown.dataset.end);
      }
      const remaining = Math.max(0, end.getTime() - Date.now());
      const values = {
        hours: Math.floor(remaining / 3600000),
        minutes: Math.floor((remaining / 60000) % 60),
        seconds: Math.floor((remaining / 1000) % 60)
      };
      Object.entries(values).forEach(([key, value]) => {
        const target = countdown.querySelector('[data-' + key + ']');
        if (target) target.textContent = String(value).padStart(2, '0');
      });
    };
    updateCountdown();
    if (window.__lstCountdownTimer) clearInterval(window.__lstCountdownTimer);
    window.__lstCountdownTimer = window.setInterval(updateCountdown, 1000);

    /* mobile reason carousel */
    const reasonList = document.querySelector('.lst-wrap .reason-list');
    const reasons = [...document.querySelectorAll('.lst-wrap .reason-list .reason')];
    const reasonCurrent = document.querySelector('.lst-wrap [data-current-reason]');
    const reasonPrevious = document.querySelector('.lst-wrap [data-reason-prev]');
    const reasonNext = document.querySelector('.lst-wrap [data-reason-next]');
    const reasonDots = [...document.querySelectorAll('.lst-wrap [data-reason-dot]')];
    let activeReason = 0;

    const updateReasonControls = (index) => {
      activeReason = Math.max(0, Math.min(reasons.length - 1, index));
      if (reasonCurrent) reasonCurrent.textContent = String(activeReason + 1);
      if (reasonPrevious) reasonPrevious.disabled = activeReason === 0;
      if (reasonNext) reasonNext.disabled = activeReason === reasons.length - 1;
      reasonDots.forEach((dot, dotIndex) => {
        if (dotIndex === activeReason) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    const goToReason = (index) => {
      const target = reasons[Math.max(0, Math.min(reasons.length - 1, index))];
      if (!target || !reasonList) return;
      /* mandatory snap cancels programmatic scrolls in Chrome; pause it for
         the jump and restore only after the scroll fully settles (restoring
         mid-animation kills the scroll and re-snaps to the start) */
      reasonList.style.scrollSnapType = 'none';
      clearTimeout(window.__lstSnapTimer);
      const restore = () => {
        clearTimeout(window.__lstSnapTimer);
        reasonList.removeEventListener('scrollend', restore);
        reasonList.style.scrollSnapType = '';
      };
      reasonList.addEventListener('scrollend', restore);
      window.__lstSnapTimer = setTimeout(restore, 2500);
      const startLeft = reasonList.scrollLeft;
      const targetLeft = target.offsetLeft - reasonList.offsetLeft;
      reasonList.scrollTo({ left: targetLeft, behavior: 'smooth' });
      /* environments that suppress smooth animations never move: fall back
         to an instant jump if nothing has happened shortly after */
      setTimeout(() => {
        if (Math.abs(reasonList.scrollLeft - startLeft) < 5 && Math.abs(targetLeft - startLeft) >= 5) {
          reasonList.scrollLeft = targetLeft;
          setTimeout(restore, 80);
        }
      }, 300);
      updateReasonControls(reasons.indexOf(target));
    };
    if (reasonList && reasons.length && !reasonList.dataset.lstBound) {
      reasonList.dataset.lstBound = '1';
      updateReasonControls(0);
      if (reasonPrevious) reasonPrevious.addEventListener('click', () => goToReason(activeReason - 1));
      if (reasonNext) reasonNext.addEventListener('click', () => goToReason(activeReason + 1));
      reasonDots.forEach((dot) => dot.addEventListener('click', () => goToReason(Number(dot.dataset.reasonDot))));
      reasonList.addEventListener('scroll', () => {
        const nearest = reasons.reduce((best, card, index) => {
          const distance = Math.abs(card.offsetLeft - reasonList.offsetLeft - reasonList.scrollLeft);
          return distance < best.distance ? { index, distance } : best;
        }, { index: 0, distance: Number.POSITIVE_INFINITY });
        updateReasonControls(nearest.index);
      }, { passive: true });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
